import type { IconProps } from './types';

export const ThreeDotsIcon = (props: IconProps) => {
  const {
    size = 24,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
    >
      <path
        d="M13.5 12C13.5 12.83 12.83 13.5 12 13.5C11.17 13.5 10.5 12.83 10.5 12C10.5 11.17 11.17 10.5 12 10.5C12.83 10.5 13.5 11.17 13.5 12ZM5 10.5C4.17 10.5 3.5 11.17 3.5 12C3.5 12.83 4.17 13.5 5 13.5C5.83 13.5 6.5 12.83 6.5 12C6.5 11.17 5.83 10.5 5 10.5ZM19 10.5C18.17 10.5 17.5 11.17 17.5 12C17.5 12.83 18.17 13.5 19 13.5C19.83 13.5 20.5 12.83 20.5 12C20.5 11.17 19.83 10.5 19 10.5Z"
        fill={color}
      />
    </svg>
  );
};
